module.exports = __webpack_public_path__ + "media/images/pc/stores/sola/icon_information-b20b2f6217aadc6e0425c54dffd80514.png";